// extracted by mini-css-extract-plugin
module.exports = {"boxes":"Styles_boxes__33SKP","box":"Styles_box__9uhNS","noTextDecoration":"Styles_noTextDecoration__3HBER"};